import React from 'react';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography/index.js';
import { buildElementStyling } from '../utils';
import { RichTextNode } from '../types';

const RichTextH1 = ({ children, value }: RichTextNode) => {
  const { className, style } = buildElementStyling({ baseClass: 'richTextH1', value });
  return (
    <Typography element="h1" className={className} style={style}>
      {children}
    </Typography>
  );
};

RichTextH1.displayName = 'RichTextH1';

export default RichTextH1;
